
import { Vue, Options } from 'vue-class-component';

@Options({
  props: {
    salonId: {
      type: String
    }
  }
})

export default class CheckboxRound extends Vue {
}

